// InlineExplainer.tsx
import React from "react";
import { Paper, Stack, Typography, useTheme } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

export default function InlineExplainer({
    text,
    onClose,
}: {
    text: string;
    onClose: () => void;
}) {
    const theme = useTheme();
    return (
        <Paper
            elevation={0}
            sx={{
                width: "95%",
                mx: "auto",
                px: 1.25,
                py: 0.75,
                //borderRadius: 2,
                //border: `1px solid ${theme.palette.divider}`,
                bgcolor: theme.palette.background.paper,
            }}
        >
            <Stack direction="row" alignItems="center" spacing={1}>
                <InfoOutlinedIcon sx={{ fontSize: 16, opacity: 0.7 }} />
                <Typography fontSize={13} sx={{ opacity: 0.9, flex: 1 }}>
                    {text}
                </Typography>
            </Stack>
        </Paper>
    );
}
